import { render, staticRenderFns } from "./Viewpoint.vue?vue&type=template&id=25b0bc24&scoped=true&"
import script from "./Viewpoint.vue?vue&type=script&lang=js&"
export * from "./Viewpoint.vue?vue&type=script&lang=js&"
import style0 from "./Viewpoint.vue?vue&type=style&index=0&id=25b0bc24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b0bc24",
  null
  
)

export default component.exports